'use strict';

module.exports = require('rc-pagination/lib/locale/zh_CN');


/*****************
 ** WEBPACK FOOTER
 ** ./components/pagination/locale/zh_CN.js
 ** module id = 209
 ** module chunks = 0
 **/